import Image from 'next/image';
import React, { FC } from 'react';
import { GameReview } from '@/utils/api/prismic/prismicClient';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { useRouter } from 'next/router';

export default function ReviewCardFlex({onReviewSelected, game, isAutoScroll}: {onReviewSelected: Function, game: GameReview, isAutoScroll: boolean}) {
  const serializer: JSXMapSerializer = {
    image: () => ( <span></span> ),
    embed: ({ node, children }) => (<span></span>)
  }

  const router = useRouter();

  const selectReview = (review: GameReview) => {
    onReviewSelected(review);

    router.push(
      {
        pathname: '/game-reviews',
        query: {
          slug: game.slug,
        },
      },
      `/game-reviews/${game.slug}`,
      {
        shallow: true,
      },
    );

    if (isAutoScroll == true) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  return (
    <button
      onClick={() => selectReview(game)}
      className='group flex flex-row gap-5 items-center bg-gradient-to-r from-[#0B0B0B] to-[#0B0B0B] hover:to-zinc-900 transition-colors duration-200 ease-in-out rounded-xl overflow-hidden h-32'
      key={game.slug}>
      <div className={'relative h-full md:w-[28rem]'}>
        <div
          style={{textShadow: '0 0 10px #000'}}
          title={`Оценка: ${game.score.label}`}
          className='absolute right-2 top-2 z-10 hover:cursor-help'>{game.score.emoji}</div>
        <Image
          src={game.cover!.sizes!.preview.url}
          alt={game.cover!.alt}
          width={200}
          height={100}
          className='w-48 md:w-64 h-full object-cover group-hover:brightness-150 transition-all duration-200 ease-in-out'/>
      </div>

      <div className={'flex flex-col gap-2 pr-5 text-left w-full '}>
        <p className='text-sm line-clamp-1 font-bold'>{game.title}</p>
        <div className={'line-clamp-3 text-sm'}>
          <PrismicRichText field={game.review} components={serializer}/></div>
      </div>
    </button>
  )
}
